module.exports = function getResource(label, vars = []) {
    let resources = {
        modalTitle: 'Please sign in to Sephora',
        beautyInsiderAlt: 'Beauty Insider'
    };

    return resources[label];
};
